import { Link, useNavigate } from "react-router-dom";
import Logo from "../images/logo/logo2.png";
import { useState } from "react";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { useAuth } from "../context/authContext";

function Navbar() {
  const [nav, setNav] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, logout } = useAuth();

  const handleSignOut = () => {
    logout();
    navigate('/signin');
  };

  const openNav = () => {
    setNav(!nav);
  };

  return (
    <>
      <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <IconX width={30} height={30} />
          </div>
          <ul className="mobile-navbar__links">
            <li>
              <Link onClick={openNav} to="/">
                Home
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/about">
                About
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/models">
                Models
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/testimonials">
                Testimonials
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/team">
                Our Team
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to="/contact">
                Contact
              </Link>
            </li>
            <li>
              {isLoggedIn ? (
                <button style={{background: 'none', border: 'none', cursor: 'pointer', color: 'white', backgroundColor: "red", padding: "1.7rem", fontWeight: "700", borderRadius: "1rem"}} onClick={handleSignOut}>Sign Out</button>
              ) : (
                <Link onClick={openNav} to="/signin">
                  Sign In
                </Link>
              )}
            </li>
            <li>
              <Link onClick={openNav} to="/register">
                Register
              </Link>
            </li>
          </ul>
        </div>

        {/* desktop */}

        <div className="navbar">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" />
            </Link>
          </div>
          <ul className="navbar__links">
            <li>
              <Link className="home-link" to="/">
                Home
              </Link>
            </li>
            <li>
              {" "}
              <Link className="about-link" to="/about">
                About
              </Link>
            </li>
            <li>
              {" "}
              <Link className="models-link" to="/models">
                Vehicle Models
              </Link>
            </li>
            <li>
              {" "}
              <Link className="testi-link" to="/testimonials">
                Testimonials
              </Link>
            </li>
            <li>
              {" "}
              <Link className="team-link" to="/team">
                Our Team
              </Link>
            </li>
            <li>
              {" "}
              <Link className="contact-link" to="/contact">
                Contact
              </Link>
            </li>
          </ul>
          <div className="navbar__buttons">
            {isLoggedIn ? (
                <button style={{background: 'none', border: 'none', cursor: 'pointer', color: 'white', backgroundColor: "red", padding: "1.7rem", fontWeight: "700", borderRadius: "1rem"}} onClick={handleSignOut}>Sign Out</button>
            ) : (
                <div>
              <Link className="navbar__buttons__sign-in" style={{marginRight: "2rem"}} to="/signin">
              Sign In
            </Link>
           
            <Link className="navbar__buttons__register" to="/register">
              Register
            </Link></div>) }
          </div>

          {/* mobile */}
          <div className="mobile-hamb" onClick={openNav}>
            <IconMenu2 width={30} height={30} />
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
